/* React */
import React, { useRef, useState, useEffect } from "react";

/* React Router Dom */
import { useLocation } from "react-router-dom";

/* Lottie */
import Lottie from "lottie-react";

/* Stylesheet */
import styles from "./Header.module.scss";

import header from "src/assets/animations/header.json";

const Header: React.FC = () => {
  const lottieRef = useRef<any>(null);
  const location = useLocation();

  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    lottieRef.current?.stop();
    setVisible(false);

    const timer = setTimeout(() => {
      if (
        location.pathname === "/imprint" &&
        lottieRef.current
      ) {
        setVisible(true);
        lottieRef.current.play();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className={styles.header}>
      <div className={styles.title_container}>
        <h1 className={styles.title}>Imprint</h1>
        <div
          style={{
            visibility: visible ? "visible" : "hidden",
          }}
        >
          <Lottie
            lottieRef={lottieRef}
            className={styles.animation}
            animationData={header}
            loop={false}
            autoplay={false}
            rendererSettings={{
              preserveAspectRatio: "none",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
